// License Hub 요약(띠/카드) 공용 색 — 요약 배경과 잔여 칸 강조색을 한 곳에서 관리한다.
export const SUMMARY_BG = '#f8fafc';
export const SUMMARY_HIGHLIGHT_BG = '#eaf0ff';
